module.exports = __webpack_public_path__ + "assets/5066d329d0e587a5d8c96dba0b595ba8.png";